import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import BookAppointment from './pages/BookAppointment';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { Grooming, Boarding, Retail } from './pages/Services';
import VeterinaryPage from './pages/VeterinaryPage';
import VeterinaryClinicNoida from './pages/VeterinaryClinicNoida';
import DogVetNoida from './pages/DogVetNoida';
import CatVetNoida from './pages/CatVetNoida';
import PetDoctorNoida from './pages/PetDoctorNoida';
import PetVaccinationNoida from './pages/PetVaccinationNoida';
import PuppyVaccinationNoida from './pages/PuppyVaccinationNoida';
import KittenVaccinationNoida from './pages/KittenVaccinationNoida';
import PetSurgeryNoida from './pages/PetSurgeryNoida';
import PetXrayNoida from './pages/PetXrayNoida';
import PetDiagnosticsNoida from './pages/PetDiagnosticsNoida';
import SpayingSurgeryNoida from './pages/SpayingSurgeryNoida';
import NeuteringSurgeryNoida from './pages/NeuteringSurgeryNoida';
import VeterinaryClinicSector137Noida from './pages/VeterinaryClinicSector137Noida';
import VeterinaryClinicSector143Noida from './pages/VeterinaryClinicSector143Noida';
import VeterinaryClinicSector168Noida from './pages/VeterinaryClinicSector168Noida';
import VeterinaryClinicSector93Noida from './pages/VeterinaryClinicSector93Noida';
import VeterinaryClinicSector128Noida from './pages/VeterinaryClinicSector128Noida';
import VeterinaryClinicSector135Noida from './pages/VeterinaryClinicSector135Noida';
import VeterinaryClinicSector150Noida from './pages/VeterinaryClinicSector150Noida';
import BringingHomePuppyOrKitten from './pages/guides/BringingHomePuppyOrKitten';
import ThankYou from './pages/ThankYou';
import SeoLandingPage from './pages/SeoLandingPage';
import HomeVetNotice from './pages/HomeVetNotice';
import Canonicalizer from './components/Canonicalizer';
import { Toaster } from './components/ui/toaster';
import ProtectedRoute from './components/ProtectedRoute';

const AppShell = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/admin" element={<AdminLogin />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Canonicalizer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/book" element={<BookAppointment />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/veterinary" element={<VeterinaryPage />} />
        <Route path="/grooming" element={<Grooming />} />
        <Route path="/boarding" element={<Boarding />} />
        <Route path="/retail" element={<Retail />} />
        {/* SEO landing pages — Noida local SEO */}
        <Route path="/veterinary-clinic-noida" element={<VeterinaryClinicNoida />} />
        <Route path="/dog-vet-noida" element={<DogVetNoida />} />
        <Route path="/cat-vet-noida" element={<CatVetNoida />} />
        <Route path="/pet-doctor-noida" element={<PetDoctorNoida />} />
        <Route path="/pet-vaccination-noida" element={<PetVaccinationNoida />} />
        <Route path="/puppy-vaccination-noida" element={<PuppyVaccinationNoida />} />
        <Route path="/kitten-vaccination-noida" element={<KittenVaccinationNoida />} />
        <Route path="/pet-surgery-noida" element={<PetSurgeryNoida />} />
        <Route path="/pet-x-ray-noida" element={<PetXrayNoida />} />
        <Route path="/pet-diagnostics-noida" element={<PetDiagnosticsNoida />} />
        <Route path="/spaying-surgery-noida" element={<SpayingSurgeryNoida />} />
        <Route path="/neutering-surgery-noida" element={<NeuteringSurgeryNoida />} />
        <Route path="/veterinary-clinic-sector-137-noida" element={<VeterinaryClinicSector137Noida />} />
        <Route path="/veterinary-clinic-sector-143-noida" element={<VeterinaryClinicSector143Noida />} />
        <Route path="/veterinary-clinic-sector-168-noida" element={<VeterinaryClinicSector168Noida />} />
        <Route path="/veterinary-clinic-sector-93-noida" element={<VeterinaryClinicSector93Noida />} />
        <Route path="/veterinary-clinic-sector-128-noida" element={<VeterinaryClinicSector128Noida />} />
        <Route path="/veterinary-clinic-sector-135-noida" element={<VeterinaryClinicSector135Noida />} />
        <Route path="/veterinary-clinic-sector-150-noida" element={<VeterinaryClinicSector150Noida />} />
        <Route path="/pet-care-guides/bringing-home-a-new-puppy-or-kitten" element={<BringingHomePuppyOrKitten />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/pet-boarding-noida" element={<SeoLandingPage />} />
        <Route path="/dog-boarding-noida" element={<SeoLandingPage />} />
        <Route path="/cat-boarding-noida" element={<SeoLandingPage />} />
        <Route path="/pet-grooming-noida" element={<SeoLandingPage />} />
        <Route path="/home-veterinary-visit-noida" element={<HomeVetNotice />} />
        <Route path="/pet-care-noida" element={<SeoLandingPage />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppShell />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
